export enum ErrorCodes {
  USER_DOES_NOT_HAVE_PERMISSION = 1_008,
  SIMILAR_ENTITIES_EXIST = 1_205,
}
